import React from 'react';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { FormControl, InputLabel, MenuItem, Select, makeStyles } from '@material-ui/core';
import classnames from 'classnames';


function AuditionSortingFilter(props) {
  const { sortOrder, setSortOrder } = props;
  const focusedColor = 'white';
  const useStyles = makeStyles({
    formControl: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '120px',
    },
    label: {
      marginRight: 'auto',
      color: '#fff',
      fontSize: '1.3em',
    },
    arrowIcon: {
      color: '#fff',
      fontSize: '30px',
      position: 'absolute',
      zIndex: 10,
      right: '20px',
      pointerEvents: 'none',
    },
    select: {
      color: '#fff',
      fontSize: '1.5em',
      border: 'none',
      width: '100%',
      position: 'relative',
      zIndex: 11,
      padding: '0px !important',
    },
    menuItem: { fontSize: '1.2em' },
    root: {
      '& label.Mui-focused': { color: focusedColor },
      '& .MuiInput-underline:after': { borderBottomColor: focusedColor },
      '& .MuiFilledInput-underline:after': { borderBottomColor: focusedColor },
      '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: focusedColor } },
    },
  });

  const handleChange = (event) => {
    setSortOrder(event.target.value);
  };

  const classes = useStyles();

  return (
    <FormControl className={classnames(classes.formControl, classes.root)}>
      <InputLabel className={classnames(classes.label, classes.root)} htmlFor="sortOrder">
        Sort By
      </InputLabel>
      <Select
        IconComponent={() => <KeyboardArrowDownIcon className={classes.arrowIcon} />}
        className={classnames(classes.select, classes.root)}
        id="sortOrder"
        label="Sort By"
        labelId="sortOrder"
        value={sortOrder}
        onChange={handleChange}
      >
        <MenuItem className={classes.menuItem} value="DESC">
          Newest
        </MenuItem>
        <MenuItem className={classes.menuItem} value="ASC">
          Oldest
        </MenuItem>
      </Select>
    </FormControl>
  );
}

export default AuditionSortingFilter;
